// Translation files for all supported languages
export const translations = {
  en: {
    translation: {
      // Common
      app_name: "TradeForge",
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      close: "Close",
      refresh: "Refresh",
      search: "Search",
      settings: "Settings",
      logout: "Logout",
      login: "Login",
      signup: "Sign Up",
      email: "Email",
      password: "Password",
      name: "Name",
      submit: "Submit",
      
      // Navigation
      nav: {
        dashboard: "Dashboard",
        signals: "Signals",
        demo_trading: "Demo Trading",
        trade_history: "Trade History",
        notifications: "Notifications",
        pricing: "Pricing",
        admin: "Admin",
        account: "Account"
      },
      
      // Dashboard
      dashboard: {
        title: "Dashboard",
        welcome: "Welcome back to your trading command center",
        active_signals: "Active Signals",
        total_trades: "Total Trades",
        unread_notifications: "Unread Notifications",
        markets_tracked: "Markets Tracked",
        market_status: "Market Status",
        market_open: "OPEN",
        market_closed: "CLOSED",
        markets_closed_weekend: "Markets are closed (Weekend)",
        signal_performance: "Signal Performance",
        based_on_outcomes: "Based on actual signal outcomes",
        win_rate: "Win Rate",
        calculating: "Calculating...",
        tp_hits: "TP Hits",
        sl_hits: "SL Hits",
        total_pips: "Total Pips",
        no_outcomes: "No signal outcomes recorded yet. Win rate will be calculated once signals are resolved.",
        trading_profile: "Your Trading Profile",
        based_on_activity: "Based on your activity",
        experience_level: "Experience Level",
        trading_style: "Trading Style",
        logins: "Logins",
        signals_viewed: "Signals Viewed",
        trades: "Trades",
        live_market_overview: "Live Market Overview",
        real_time_data: "Real-Time Data",
        cached_data: "Cached Data",
        last_updated: "Last updated",
        recent_signals: "Recent Signals",
        view_all_signals: "View All Signals",
        no_active_signals: "No active signals available",
        entry_zone: "Entry Zone",
        stop_loss: "Stop Loss",
        take_profit: "Take Profit",
        view_signal: "View Signal",
        live_news_stream: "24/7 Live News Stream",
        live_market_news: "Live Market News"
      },
      
      // Signals
      signals: {
        title: "Trading Signals",
        subtitle: "Professional trading signals with entry/exit points",
        new_signal: "New Signal",
        active: "Active",
        closed: "Closed",
        all: "All",
        buy: "BUY",
        sell: "SELL",
        confidence: "Confidence",
        high: "HIGH",
        medium: "MEDIUM",
        low: "LOW",
        risk_reward: "Risk/Reward",
        auto_trade: "Auto Trade",
        connect_broker: "Connect Broker"
      },
      
      // Auth
      auth: {
        login_title: "Welcome Back",
        login_subtitle: "Sign in to access your trading dashboard",
        signup_title: "Create Account",
        signup_subtitle: "Join TradeForge and start trading smarter",
        forgot_password: "Forgot password?",
        no_account: "Don't have an account?",
        have_account: "Already have an account?",
        or_continue_with: "Or continue with",
        google_login: "Continue with Google"
      },
      
      // Settings
      settings: {
        title: "Settings",
        appearance: "Appearance",
        language: "Language",
        theme: "Theme",
        dark_mode: "Dark Mode",
        light_mode: "Light Mode",
        system: "System",
        notifications_settings: "Notification Settings",
        email_notifications: "Email Notifications",
        push_notifications: "Push Notifications",
        telegram_notifications: "Telegram Notifications"
      },
      
      // Telegram
      telegram: {
        join: "Join Telegram",
        get_signals: "Get signals & weekly analysis",
        subscribe: "Subscribe to our Telegram channel for instant signal alerts"
      },
      
      // Pricing
      pricing: {
        title: "Choose Your Plan",
        subtitle: "Unlock premium features and advanced trading signals",
        free: "Free",
        pro: "Pro",
        monthly: "Monthly",
        yearly: "Yearly",
        current_plan: "Current Plan",
        upgrade: "Upgrade",
        features: "Features"
      },
      
      // Chat
      chat: {
        title: "AI Support",
        online: "Online 24/7",
        placeholder: "Type your message...",
        powered_by: "Powered by GPT-5.2"
      },
      
      // Errors
      errors: {
        something_went_wrong: "Something went wrong",
        unexpected_error: "We encountered an unexpected error. Please try refreshing the page.",
        refresh_page: "Refresh Page",
        session_expired: "Session expired. Please log in again.",
        loading_failed: "Failed to load data. Please try again."
      },
      
      // Time
      time: {
        just_now: "Just now",
        minutes_ago: "{{count}} minutes ago",
        hours_ago: "{{count}} hours ago",
        days_ago: "{{count}} days ago"
      }
    }
  },
  
  ar: {
    translation: {
      // Common
      app_name: "تريد فورج",
      loading: "جاري التحميل...",
      save: "حفظ",
      cancel: "إلغاء",
      confirm: "تأكيد",
      close: "إغلاق",
      refresh: "تحديث",
      search: "بحث",
      settings: "الإعدادات",
      logout: "تسجيل الخروج",
      login: "تسجيل الدخول",
      signup: "إنشاء حساب",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      name: "الاسم",
      submit: "إرسال",
      
      // Navigation
      nav: {
        dashboard: "لوحة التحكم",
        signals: "الإشارات",
        demo_trading: "التداول التجريبي",
        trade_history: "سجل التداول",
        notifications: "الإشعارات",
        pricing: "الأسعار",
        admin: "الإدارة",
        account: "الحساب"
      },
      
      // Dashboard
      dashboard: {
        title: "لوحة التحكم",
        welcome: "مرحباً بعودتك إلى مركز التداول الخاص بك",
        active_signals: "الإشارات النشطة",
        total_trades: "إجمالي الصفقات",
        unread_notifications: "إشعارات غير مقروءة",
        markets_tracked: "الأسواق المتابعة",
        market_status: "حالة السوق",
        market_open: "مفتوح",
        market_closed: "مغلق",
        markets_closed_weekend: "الأسواق مغلقة (عطلة نهاية الأسبوع)",
        signal_performance: "أداء الإشارات",
        based_on_outcomes: "بناءً على نتائج الإشارات الفعلية",
        win_rate: "نسبة الربح",
        calculating: "جاري الحساب...",
        tp_hits: "أهداف محققة",
        sl_hits: "وقف خسارة",
        total_pips: "إجمالي النقاط",
        no_outcomes: "لم يتم تسجيل نتائج إشارات بعد. سيتم حساب نسبة الربح عند إغلاق الإشارات.",
        trading_profile: "ملفك التداولي",
        based_on_activity: "بناءً على نشاطك",
        experience_level: "مستوى الخبرة",
        trading_style: "أسلوب التداول",
        logins: "تسجيلات الدخول",
        signals_viewed: "الإشارات المعروضة",
        trades: "الصفقات",
        live_market_overview: "نظرة عامة على السوق",
        real_time_data: "بيانات فورية",
        cached_data: "بيانات مخزنة",
        last_updated: "آخر تحديث",
        recent_signals: "أحدث الإشارات",
        view_all_signals: "عرض جميع الإشارات",
        no_active_signals: "لا توجد إشارات نشطة",
        entry_zone: "منطقة الدخول",
        stop_loss: "وقف الخسارة",
        take_profit: "جني الأرباح",
        view_signal: "عرض الإشارة",
        live_news_stream: "البث المباشر للأخبار",
        live_market_news: "أخبار السوق المباشرة"
      },
      
      // Signals
      signals: {
        title: "إشارات التداول",
        subtitle: "إشارات تداول احترافية مع نقاط الدخول والخروج",
        new_signal: "إشارة جديدة",
        active: "نشطة",
        closed: "مغلقة",
        all: "الكل",
        buy: "شراء",
        sell: "بيع",
        confidence: "الثقة",
        high: "عالية",
        medium: "متوسطة",
        low: "منخفضة",
        risk_reward: "المخاطرة/المكافأة",
        auto_trade: "تداول تلقائي",
        connect_broker: "ربط الوسيط"
      },
      
      // Auth
      auth: {
        login_title: "مرحباً بعودتك",
        login_subtitle: "سجل دخولك للوصول إلى لوحة التداول",
        signup_title: "إنشاء حساب",
        signup_subtitle: "انضم إلى تريد فورج وابدأ التداول بذكاء",
        forgot_password: "نسيت كلمة المرور؟",
        no_account: "ليس لديك حساب؟",
        have_account: "لديك حساب بالفعل؟",
        or_continue_with: "أو تابع مع",
        google_login: "تسجيل الدخول بجوجل"
      },
      
      // Settings
      settings: {
        title: "الإعدادات",
        appearance: "المظهر",
        language: "اللغة",
        theme: "السمة",
        dark_mode: "الوضع الداكن",
        light_mode: "الوضع الفاتح",
        system: "تلقائي",
        notifications_settings: "إعدادات الإشعارات",
        email_notifications: "إشعارات البريد",
        push_notifications: "الإشعارات الفورية",
        telegram_notifications: "إشعارات تيليجرام"
      },
      
      // Telegram
      telegram: {
        join: "انضم للتيليجرام",
        get_signals: "احصل على الإشارات والتحليل الأسبوعي",
        subscribe: "اشترك في قناتنا على تيليجرام للحصول على تنبيهات فورية"
      },
      
      // Pricing
      pricing: {
        title: "اختر خطتك",
        subtitle: "افتح الميزات المتقدمة وإشارات التداول الاحترافية",
        free: "مجاني",
        pro: "احترافي",
        monthly: "شهري",
        yearly: "سنوي",
        current_plan: "الخطة الحالية",
        upgrade: "ترقية",
        features: "الميزات"
      },
      
      // Chat
      chat: {
        title: "الدعم الذكي",
        online: "متاح 24/7",
        placeholder: "اكتب رسالتك...",
        powered_by: "مدعوم من GPT-5.2"
      },
      
      // Errors
      errors: {
        something_went_wrong: "حدث خطأ ما",
        unexpected_error: "واجهنا خطأً غير متوقع. يرجى تحديث الصفحة.",
        refresh_page: "تحديث الصفحة",
        session_expired: "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.",
        loading_failed: "فشل تحميل البيانات. يرجى المحاولة مرة أخرى."
      },
      
      // Time
      time: {
        just_now: "الآن",
        minutes_ago: "منذ {{count}} دقيقة",
        hours_ago: "منذ {{count}} ساعة",
        days_ago: "منذ {{count}} يوم"
      }
    }
  },
  
  es: {
    translation: {
      app_name: "TradeForge",
      loading: "Cargando...",
      save: "Guardar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      close: "Cerrar",
      refresh: "Actualizar",
      search: "Buscar",
      settings: "Configuración",
      logout: "Cerrar sesión",
      login: "Iniciar sesión",
      signup: "Registrarse",
      email: "Correo electrónico",
      password: "Contraseña",
      name: "Nombre",
      submit: "Enviar",
      nav: {
        dashboard: "Panel",
        signals: "Señales",
        demo_trading: "Trading Demo",
        trade_history: "Historial",
        notifications: "Notificaciones",
        pricing: "Precios",
        admin: "Admin",
        account: "Cuenta"
      },
      dashboard: {
        title: "Panel de Control",
        welcome: "Bienvenido a tu centro de trading",
        active_signals: "Señales Activas",
        total_trades: "Total de Operaciones",
        unread_notifications: "Notificaciones sin leer",
        markets_tracked: "Mercados Seguidos",
        market_status: "Estado del Mercado",
        market_open: "ABIERTO",
        market_closed: "CERRADO",
        live_market_overview: "Resumen del Mercado en Vivo",
        real_time_data: "Datos en Tiempo Real",
        recent_signals: "Señales Recientes",
        view_all_signals: "Ver Todas las Señales"
      },
      settings: {
        title: "Configuración",
        appearance: "Apariencia",
        language: "Idioma",
        theme: "Tema",
        dark_mode: "Modo Oscuro",
        light_mode: "Modo Claro",
        system: "Sistema"
      },
      errors: {
        something_went_wrong: "Algo salió mal",
        unexpected_error: "Encontramos un error inesperado. Por favor, actualiza la página.",
        refresh_page: "Actualizar Página"
      }
    }
  },
  
  fr: {
    translation: {
      app_name: "TradeForge",
      loading: "Chargement...",
      save: "Enregistrer",
      cancel: "Annuler",
      confirm: "Confirmer",
      close: "Fermer",
      refresh: "Actualiser",
      search: "Rechercher",
      settings: "Paramètres",
      logout: "Déconnexion",
      login: "Connexion",
      signup: "S'inscrire",
      email: "E-mail",
      password: "Mot de passe",
      name: "Nom",
      submit: "Envoyer",
      nav: {
        dashboard: "Tableau de bord",
        signals: "Signaux",
        demo_trading: "Trading Démo",
        trade_history: "Historique",
        notifications: "Notifications",
        pricing: "Tarifs",
        admin: "Admin",
        account: "Compte"
      },
      dashboard: {
        title: "Tableau de Bord",
        welcome: "Bienvenue dans votre centre de trading",
        active_signals: "Signaux Actifs",
        total_trades: "Total des Trades",
        unread_notifications: "Notifications non lues",
        markets_tracked: "Marchés Suivis",
        market_status: "État du Marché",
        market_open: "OUVERT",
        market_closed: "FERMÉ",
        live_market_overview: "Aperçu du Marché en Direct",
        real_time_data: "Données en Temps Réel",
        recent_signals: "Signaux Récents",
        view_all_signals: "Voir Tous les Signaux"
      },
      settings: {
        title: "Paramètres",
        appearance: "Apparence",
        language: "Langue",
        theme: "Thème",
        dark_mode: "Mode Sombre",
        light_mode: "Mode Clair",
        system: "Système"
      },
      errors: {
        something_went_wrong: "Une erreur s'est produite",
        unexpected_error: "Nous avons rencontré une erreur inattendue. Veuillez actualiser la page.",
        refresh_page: "Actualiser la Page"
      }
    }
  },
  
  de: {
    translation: {
      app_name: "TradeForge",
      loading: "Laden...",
      save: "Speichern",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      close: "Schließen",
      refresh: "Aktualisieren",
      search: "Suchen",
      settings: "Einstellungen",
      logout: "Abmelden",
      login: "Anmelden",
      signup: "Registrieren",
      nav: {
        dashboard: "Dashboard",
        signals: "Signale",
        demo_trading: "Demo-Trading",
        trade_history: "Handelsverlauf",
        notifications: "Benachrichtigungen",
        pricing: "Preise",
        admin: "Admin",
        account: "Konto"
      },
      dashboard: {
        title: "Dashboard",
        welcome: "Willkommen in Ihrem Trading-Zentrum",
        active_signals: "Aktive Signale",
        total_trades: "Gesamte Trades",
        live_market_overview: "Live-Marktübersicht",
        real_time_data: "Echtzeit-Daten"
      },
      settings: {
        title: "Einstellungen",
        appearance: "Erscheinungsbild",
        language: "Sprache",
        theme: "Design",
        dark_mode: "Dunkelmodus",
        light_mode: "Hellmodus"
      }
    }
  },
  
  zh: {
    translation: {
      app_name: "TradeForge",
      loading: "加载中...",
      save: "保存",
      cancel: "取消",
      confirm: "确认",
      close: "关闭",
      refresh: "刷新",
      search: "搜索",
      settings: "设置",
      logout: "退出",
      login: "登录",
      signup: "注册",
      nav: {
        dashboard: "仪表板",
        signals: "信号",
        demo_trading: "模拟交易",
        trade_history: "交易历史",
        notifications: "通知",
        pricing: "定价",
        admin: "管理",
        account: "账户"
      },
      dashboard: {
        title: "仪表板",
        welcome: "欢迎回到您的交易中心",
        active_signals: "活跃信号",
        total_trades: "总交易",
        live_market_overview: "实时市场概览",
        real_time_data: "实时数据"
      },
      settings: {
        title: "设置",
        appearance: "外观",
        language: "语言",
        theme: "主题",
        dark_mode: "深色模式",
        light_mode: "浅色模式"
      }
    }
  },
  
  ja: {
    translation: {
      app_name: "TradeForge",
      loading: "読み込み中...",
      save: "保存",
      cancel: "キャンセル",
      confirm: "確認",
      close: "閉じる",
      refresh: "更新",
      search: "検索",
      settings: "設定",
      logout: "ログアウト",
      login: "ログイン",
      signup: "登録",
      nav: {
        dashboard: "ダッシュボード",
        signals: "シグナル",
        demo_trading: "デモ取引",
        trade_history: "取引履歴",
        notifications: "通知",
        pricing: "料金",
        admin: "管理",
        account: "アカウント"
      },
      dashboard: {
        title: "ダッシュボード",
        welcome: "トレーディングセンターへようこそ",
        active_signals: "アクティブシグナル",
        total_trades: "総取引数",
        live_market_overview: "ライブ市場概要",
        real_time_data: "リアルタイムデータ"
      },
      settings: {
        title: "設定",
        appearance: "外観",
        language: "言語",
        theme: "テーマ",
        dark_mode: "ダークモード",
        light_mode: "ライトモード"
      }
    }
  },
  
  ko: {
    translation: {
      app_name: "TradeForge",
      loading: "로딩 중...",
      save: "저장",
      cancel: "취소",
      confirm: "확인",
      close: "닫기",
      refresh: "새로고침",
      search: "검색",
      settings: "설정",
      logout: "로그아웃",
      login: "로그인",
      signup: "회원가입",
      nav: {
        dashboard: "대시보드",
        signals: "시그널",
        demo_trading: "데모 트레이딩",
        trade_history: "거래 내역",
        notifications: "알림",
        pricing: "가격",
        admin: "관리자",
        account: "계정"
      },
      dashboard: {
        title: "대시보드",
        welcome: "트레이딩 센터에 오신 것을 환영합니다",
        active_signals: "활성 시그널",
        total_trades: "총 거래",
        live_market_overview: "실시간 시장 개요",
        real_time_data: "실시간 데이터"
      },
      settings: {
        title: "설정",
        appearance: "외관",
        language: "언어",
        theme: "테마",
        dark_mode: "다크 모드",
        light_mode: "라이트 모드"
      }
    }
  },
  
  ru: {
    translation: {
      app_name: "TradeForge",
      loading: "Загрузка...",
      save: "Сохранить",
      cancel: "Отмена",
      confirm: "Подтвердить",
      close: "Закрыть",
      refresh: "Обновить",
      search: "Поиск",
      settings: "Настройки",
      logout: "Выйти",
      login: "Войти",
      signup: "Регистрация",
      nav: {
        dashboard: "Панель",
        signals: "Сигналы",
        demo_trading: "Демо торговля",
        trade_history: "История сделок",
        notifications: "Уведомления",
        pricing: "Цены",
        admin: "Админ",
        account: "Аккаунт"
      },
      dashboard: {
        title: "Панель управления",
        welcome: "Добро пожаловать в ваш торговый центр",
        active_signals: "Активные сигналы",
        total_trades: "Всего сделок",
        live_market_overview: "Обзор рынка в реальном времени",
        real_time_data: "Данные в реальном времени"
      },
      settings: {
        title: "Настройки",
        appearance: "Внешний вид",
        language: "Язык",
        theme: "Тема",
        dark_mode: "Тёмная тема",
        light_mode: "Светлая тема"
      }
    }
  },
  
  pt: {
    translation: {
      app_name: "TradeForge",
      loading: "Carregando...",
      save: "Salvar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      close: "Fechar",
      refresh: "Atualizar",
      search: "Buscar",
      settings: "Configurações",
      logout: "Sair",
      login: "Entrar",
      signup: "Cadastrar",
      nav: {
        dashboard: "Painel",
        signals: "Sinais",
        demo_trading: "Trading Demo",
        trade_history: "Histórico",
        notifications: "Notificações",
        pricing: "Preços",
        admin: "Admin",
        account: "Conta"
      },
      dashboard: {
        title: "Painel de Controle",
        welcome: "Bem-vindo ao seu centro de trading",
        active_signals: "Sinais Ativos",
        total_trades: "Total de Operações",
        live_market_overview: "Visão Geral do Mercado ao Vivo",
        real_time_data: "Dados em Tempo Real"
      },
      settings: {
        title: "Configurações",
        appearance: "Aparência",
        language: "Idioma",
        theme: "Tema",
        dark_mode: "Modo Escuro",
        light_mode: "Modo Claro"
      }
    }
  },
  
  tr: {
    translation: {
      app_name: "TradeForge",
      loading: "Yükleniyor...",
      save: "Kaydet",
      cancel: "İptal",
      confirm: "Onayla",
      close: "Kapat",
      refresh: "Yenile",
      search: "Ara",
      settings: "Ayarlar",
      logout: "Çıkış",
      login: "Giriş",
      signup: "Kayıt Ol",
      nav: {
        dashboard: "Panel",
        signals: "Sinyaller",
        demo_trading: "Demo Trading",
        trade_history: "İşlem Geçmişi",
        notifications: "Bildirimler",
        pricing: "Fiyatlar",
        admin: "Yönetici",
        account: "Hesap"
      },
      dashboard: {
        title: "Kontrol Paneli",
        welcome: "Trading merkezinize hoş geldiniz",
        active_signals: "Aktif Sinyaller",
        total_trades: "Toplam İşlemler",
        live_market_overview: "Canlı Piyasa Özeti",
        real_time_data: "Gerçek Zamanlı Veri"
      },
      settings: {
        title: "Ayarlar",
        appearance: "Görünüm",
        language: "Dil",
        theme: "Tema",
        dark_mode: "Karanlık Mod",
        light_mode: "Aydınlık Mod"
      }
    }
  },
  
  hi: {
    translation: {
      app_name: "TradeForge",
      loading: "लोड हो रहा है...",
      save: "सहेजें",
      cancel: "रद्द करें",
      confirm: "पुष्टि करें",
      close: "बंद करें",
      refresh: "रीफ्रेश",
      search: "खोजें",
      settings: "सेटिंग्स",
      logout: "लॉग आउट",
      login: "लॉग इन",
      signup: "साइन अप",
      nav: {
        dashboard: "डैशबोर्ड",
        signals: "सिग्नल",
        demo_trading: "डेमो ट्रेडिंग",
        trade_history: "ट्रेड इतिहास",
        notifications: "सूचनाएं",
        pricing: "मूल्य निर्धारण",
        admin: "एडमिन",
        account: "खाता"
      },
      dashboard: {
        title: "डैशबोर्ड",
        welcome: "अपने ट्रेडिंग सेंटर में आपका स्वागत है",
        active_signals: "सक्रिय सिग्नल",
        total_trades: "कुल ट्रेड"
      },
      settings: {
        title: "सेटिंग्स",
        appearance: "दिखावट",
        language: "भाषा",
        theme: "थीम",
        dark_mode: "डार्क मोड",
        light_mode: "लाइट मोड"
      }
    }
  }
};

// Language options with native names
export const languageOptions = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', rtl: true },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪' },
  { code: 'zh', name: 'Chinese', nativeName: '中文', flag: '🇨🇳' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', flag: '🇰🇷' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский', flag: '🇷🇺' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇧🇷' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', flag: '🇹🇷' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳' }
];
